import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageName:'',
    carrinho: [],
    desejos: [],
    images: {},
    // Resumo de avaliações por produto { [id]: { media, total } } (estrelas dos cards).
    avaliacoesResumo: {},
    // Condições de venda configuradas na Precificação ({ config, rankings }) - ver services/condicoesVenda.js.
    condicoesVenda: { config: null, rankings: {} },
    imagensDeProduto:[],
    categoriasProdutos:{},
    configuracoesSite: {
      ocultar_preco_nao_logado: false,
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
